import React, {useCallback} from 'react';

import {copy} from 'src/utils/copyToClipboard';

import {Icons, Sizes} from '@pb/kit-component-icon';
import {IconSize} from '@pb/kit-component-icon/dist/constants';
import {BasicIconButton} from '@pb/kit-component-icon-button';

type Props = {
    textToCopy: string,
    size?: IconSize,
};

export const CopyButton = ({textToCopy, size = Sizes.Size_14}: Props) => {
    const onClick = useCallback(() => {
        copy(textToCopy);
    }, [textToCopy]);

    return (
        <BasicIconButton iconProps={{type: Icons.COPY, size}} onClick={onClick}/>
    );
};
